import { ref, computed } from 'vue-demi';
import { CHILD_MAIN, MAIN_STATUS, RECEIVED_STATUS_ARR } from '../common/constant';


export default (props) => {
    const mainStatus = ref(MAIN_STATUS.UNRECEIVED);

    const setMainStatus = (receiveStatus) => {
        mainStatus.value = RECEIVED_STATUS_ARR.includes(receiveStatus)
            ? MAIN_STATUS.RECEIVED
            : MAIN_STATUS.UNRECEIVED;
    };

    const main = computed(() => {
        return props.tpl.children.filter((item) => item.type === CHILD_MAIN && item.props.status === mainStatus.value);
    });

    return {
        setMainStatus,
        main
    };
};
